import { MULTI_FILTER_PLACEHOLDERS, MULTI_FILTER_SELECTED_PLACEHOLDERS } from './constants';
import type { VisaoGeralElasticidadeFiltroOutrosBody, VisaoGeralElasticidadeMultiFilterType } from './types';

export const buildFilterRequestPayload = (
  name: VisaoGeralElasticidadeMultiFilterType | 'manufacturers',
  filtersBody: VisaoGeralElasticidadeFiltroOutrosBody,
  query = '',
): VisaoGeralElasticidadeFiltroOutrosBody => ({
  ...filtersBody,
  query,
  [name]: [],
});

export function formatPercent1Decimal(value?: number | null): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '--';

  const formattedValue = value?.toFixed(1).replace('.', ',');

  return `${formattedValue}%`;
}

export function formatDecimal2(value?: number | null): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '--';

  return value.toFixed(2).replace('.', ',');
}

export function formatIsoDateToBr(isoDateTime?: string | null): string {
  if (!isoDateTime) return '--';

  const [year, month, day] = isoDateTime.split('T')[0].split('-');
  if (!year || !month || !day) return '--';

  return `${day}/${month}/${year}`;
}

export function buildMultiSelectPlaceholder(name: VisaoGeralElasticidadeMultiFilterType, values: string[]): string {
  if (!values.length) return MULTI_FILTER_PLACEHOLDERS[name];
  return `${MULTI_FILTER_SELECTED_PLACEHOLDERS[name]}`;
}
